import request from '@/utils/request'


// 仓库查询
export function pageQuery(data) {
    return request({
        url: '/db/warehouse-info/query',
        method: 'post',
        data
    })
}

// 添加仓库
export function addWms(data) {
    return request({
        url: '/db/warehouse-info/add',
        method: 'post',
        data
    })
}

//编辑仓库
export function updWms(data) {
    return request({
        url: '/db/warehouse-info/update',
        method: 'post',
        data
    })
}

//仓库状态修改
export function updStatusWms(data) {
    return request({
        url: '/db/warehouse-info/updateStatus',
        method: 'put',
        params: data
    })
}


// 医院列表查询
export function pageQueryHosp(data) {
    return request({
        url: '/db/warehouse-info/hosp-page-query',
        method: 'post',
        data
    })
}


// 添加关联医院
export function addRelHosp(data) {
    return request({
        url: '/db/warehouse-info/addHosp',
        method: 'post',
        data
    })
}






